import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
  Grid,
  Avatar,
  Typography,
  Button,
  Icon,
  Hidden
} from "@material-ui/core";
import ImageGallery from 'react-image-gallery';
import { client } from "../../config/apollo";
import {
  parentContainer,
  webFont,
  textBlack,
  primaryColor,
  textGrey,
  fontColor
} from "../../config/theme";
import Header from "../Header";
import {Helmet} from "react-helmet";
import { GET_DISH } from "../../graphql/queries/dishes";
import {GET_CHEF_DETAILS} from "../../graphql/queries/chef";
import { DISH_TYPES } from "../../config/constants";
import { FAV, UNFAV } from "../../graphql/mutations/user";
import IconButton from "@material-ui/core/IconButton/IconButton";
import { GET_SAVED_DISHES } from "../../graphql/queries/user";
import { NotificationManager } from "react-notifications";
import {capitalize} from "../../utils/validate-data";
import Breadcrumbs from "../Breadcrumbs";
const defaultChefImg = "/images/simple-chef.webp";


const DishDetails = props => {
  const [chef, setChef] = useState({});
  const [dish, setDish] = useState({});
  const [dishId, setDishId] = useState(null);
  const [viewAsDiner, setViewAsDiner] = useState(false);
  const [liked, setLiked] = useState(false);
  const [savedDishes, setSavedDishes] = useState([]);

  const checkLiked = () => {
    if (props.userId) {
      // fetch if dish is liked or not
      client.query({
        query: GET_SAVED_DISHES,
        variables: {
          userId: props.userId,
          pageSize: 100
        },
      })
        .then(savedResp => {
          if (savedResp.data) {
            const savedDishesInMethod = savedResp.data.savedDishes;
            setSavedDishes(savedDishesInMethod);
            let isSameDish = false;

            if (savedDishesInMethod.dishes && savedDishesInMethod.dishes.length > 0) {
              const index = savedDishesInMethod.dishes.findIndex(item => item.id === dishId);

              if (index > -1) {
                isSameDish = true;
              }
            }
            setLiked(isSameDish);
          }
        })
        .catch(e => console.error('ERR Fetching saved dish details: ', e));
    }
  };

  useEffect(() => {
    if (props.location.state) {
      const state = props.location.state;
      setViewAsDiner(state.viewAsDiner);
      setDishId(state.dishId);
      setLiked(state.liked);

      client.query({
        query: GET_DISH,
        variables: {
          id: state.dishId
        }
      })
        .then(dishResp => {
          if (dishResp.data) {
            setDish(dishResp.data.dish);

            // fetch chef details
            client.query({
              query: GET_CHEF_DETAILS,
              variables: {
                id: dishResp.data.dish.chefId,
              }
            })
              .then(chefResp => {
                if (chefResp.data) {
                  setChef(chefResp.data.chef);
                }
              })
              .catch(e => console.error('ERR fetching chef details for dish'));
          }
        })
        .catch(err => console.error('ERR Fetching dish details: ', err));
    }
  }, [props.location]);

  useEffect(() => {
    checkLiked();
  }, [props.userId, dishId]);

  const like = dishId => {
    const { userId } = props;
    let isSameDish = false;

    if (savedDishes.dishes && savedDishes.dishes.length > 0) {
      const index = savedDishes.dishes.findIndex(item => item.id === dishId);

      if (index > -1) {
        isSameDish = true;
      }
    }

    setLiked(!isSameDish);
    if (isSameDish) {
      client
        .mutate({
          mutation: UNFAV,
          variables: {
            userId,
            itemsToDelete: { dishes: [dishId] }
          }
        })
        .then(res => {
          setLiked(false);
          const sDishes = {...savedDishes};
          const index = sDishes.dishes.findIndex(item => item.id === dishId);
          if (index > -1) {
            sDishes.dishes.splice(index, 1);
            setSavedDishes(sDishes);
          }
        })
        .catch(err => {
          console.log(err);
        });
    } else {
      client
        .mutate({
          mutation: FAV,
          variables: {
            userId,
            itemsToAdd: { dishes: [dishId] }
          }
        })
        .then(res => {
          setLiked(true);
          const sDishes = {...savedDishes};
          sDishes.dishes.push(dish);
          setSavedDishes(sDishes);
        })
        .catch(err => {
          console.log(err);
        });
    }
  };

  const showChefProfile = dish => {
    if (viewAsDiner || (props.isChef && dish.chefId === props.userId)) {
      NotificationManager.info('The diner will be taken through the booking flow', 'Dish details');
      return;
    }
    props.history.push(`/home/chef-profile?dish_id=${dish.id}`, { chefId: dish.chefId });
  };

  const renderImgItem = (item) => {
    return (
      <React.Fragment>
        <Hidden mdDown>
          <Avatar
            src={item.original}
            alt={item.originalAlt}
            style={style.avatarImgWeb}
          />
        </Hidden>
        <Hidden only={['lg', 'xl']}>
          <Avatar
            src={item.original}
            alt={item.originalAlt}
            style={style.avatarImg}
          />
        </Hidden>
      </React.Fragment>
    );
  };

  let dishTypes = <div />;

  let isFav = false;
  if (savedDishes && savedDishes.dishes && savedDishes.dishes.length > 0) {
    const dishIndex = savedDishes.dishes.findIndex(item => item === dish.id);
    if (dishIndex > -1) {
      isFav = true;
    }
  }

  if (dish.dishTypes) {
    dishTypes = dish.dishTypes.map(dType => {
      const index = DISH_TYPES.findIndex(
        item => item.name === dType || item.display === dType
      );
      if (index > -1) {
        const dishType = DISH_TYPES[index];
        if (index === 0) {
          return (
            <Grid item xs={2} md={1} key={dishType.name} style={{ maxWidth: 'inherit', flexBasis: 'auto', textAlign: 'center', marginRight: 15 }}>
              <Button
                data-test-id={"dishdet-dishtype"}
                size="small"
                variant="contained"
                style={style.btnDishTypeSelected}
              >
                {capitalize(dishType.display)}
              </Button>
            </Grid>
          );
        } else {
          return (
            <Grid item xs={2} md={1} key={dishType.name} style={{ maxWidth: 'inherit', flexBasis: 'auto', textAlign: 'center', marginRight: 30 }}>
              <Button
                data-test-id={"dishdet-dishtype"}
                size="small"
                variant="contained"
                style={style.btnDishTypeSelected}
              >
                {capitalize(dishType.display)}
              </Button>
            </Grid>
          );
        }

      } else {
        return <div />;
      }
    });
  }

  const imgItems = [];

  if (dish.media && dish.media.length) {
    dish.media.forEach(img => {
      imgItems.push({
        original: img.url,
        originalAlt: dish.name,
        renderItem: renderImgItem
      });
    });
  }

  const screen = props.location && props.location.state && props.location.state.screen ?
    props.location.state.screen : '';

  let childRoutes = [
    {
      display: 'Dish Details',
      link: 'home/dish-details'
    },
  ];

  if (screen === 'saved') {
    childRoutes = [{
      display: 'Saved',
      link: 'home/saved'
    },{
      display: 'Dish Details',
      link: 'home/dish-details'
    }];
  } if (screen === 'dish-search') {
    childRoutes = [{
      display: 'Dishes',
      link: 'home/dish-search'
    },{
      display: 'Dish Details',
      link: 'home/dish-details'
    }];
  }
  if (props.viewAsDiner) {
    childRoutes = [{
      display: 'View As Diner',
      link: '#'
    }, {
      display: 'Dish Details',
      link: 'home/dish-details'
    }];
  }

  return (
    <div style={parentContainer}>
      <Helmet>
        <title>
          {!!dish && dish.name ? dish.name : 'Dish'} - Cuisine Crafters
        </title>
        {!!dish && dish.slug &&
          <link rel="canonical" href={`https://cuisinecrafters.net/dish/${dish.slug}`} />
        }

        {!!dish && dish.description &&
          <meta name="description" content={dish.description} />
        }
      </Helmet>
      <Grid container>
        <Grid item xs={12} style={{ marginBottom: 60 }}>
          <Header {...props} />
          {!!chef && chef.username &&
            <a href={`/chef/profile/${chef.username}`}>{dish.chefName}</a>
          }
        </Grid>

        <Grid container direction="row" className="dish-container-custom-details">
          <Grid item xs={12} style={{ marginBottom: 30 }}>
            <Breadcrumbs childRoutes={childRoutes} />
          </Grid>
          <Grid item xs={12}>
            <Grid container direction="row">
              <Hidden only={['lg', 'xl']}>
                <Grid data-test-id={"dishdet-img"}
                      item xs={12} sm={8} md={8} lg={8}>
                  {dish.media && dish.media.length ?
                    <ImageGallery
                      autoPlay={true}
                      items={imgItems}
                      lazyLoad={true}
                      infinte={true}
                      showBullets={true}
                      showFullscreenButton={false}
                      showNav={false}
                      showPlayButton={false}
                      showThumbnails={false}
                      showIndex={false}
                      slideDuration={450}
                      slideInterval={3500}
                    /> :
                    <Avatar
                      src={defaultChefImg}
                      alt="Image not available"
                      style={style.avatarImg}
                    />
                  }
                </Grid>
              </Hidden>
              <Hidden mdDown>
                <Grid data-test-id={"dishdet-img"}
                      item xs={12} sm={8} md={8} lg={9}>
                  {dish.media && dish.media.length ?
                    <ImageGallery
                      autoPlay={true}
                      items={imgItems}
                      lazyLoad={true}
                      infinte={true}
                      showBullets={true}
                      showFullscreenButton={false}
                      showNav={false}
                      showPlayButton={false}
                      showThumbnails={false}
                      showIndex={false}
                      slideDuration={450}
                      slideInterval={3500}
                    /> :
                    <Avatar
                      src={defaultChefImg}
                      alt="Image not available"
                      style={style.avatarImgWeb}
                    />
                  }
                </Grid>
              </Hidden>
              <Hidden only={['xs', 'lg', 'xl']}>
                <Grid item sm={1} lg={1}></Grid>
              </Hidden>
              <Grid item xs={12} sm={3} md={3} lg={3} style={{ alignItems: "center", justifyContent: "center", display: 'flex' }}>
                <Grid item xs={12} style={{ width: '100%', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', textAlign: 'center', marginBottom: 10, marginTop: 10 }}>
                  <Typography variant="subtitle1" style={{ textAlign: 'center', fontFamily: 'Poppins', fontWeight: 400 }} gutterBottom={true}>
                    Offered by
                  </Typography>
                  <img
                    src={chef ? chef.profilePic : defaultChefImg}
                    alt={'Chef image'}
                    width={180}
                    height={180}
                    style={{ width: 180, height: 180, margin: '5px auto', borderRadius: '50%' }}
                  />
                  <div style={{ width: '100%' }}>
                    <Typography variant="p" style={{ textAlign: 'center', fontFamily: 'Poppins', fontWeight: 400}}>
                      {chef ? chef.firstName : ''} {chef ? chef.lastName : ''}
                    </Typography>
                  </div>
                  <Button data-test-id={"dishdet-bookchef"} style={{borderRadius: 25,
                    backgroundColor: primaryColor,
                    border: "none",
                    width: 180,
                    color: "white",
                    height: 40,
                    fontFamily: webFont,
                    marginTop: 10,
                    textTransform: "none"}}
                          onClick={() => showChefProfile(dish)}
                  >
                    Book Now</Button>
                </Grid>
                </Grid>
              <Grid
                data-test-id={"dishdet-name"}
                item xs={12}>
                <Grid container>
                  <Grid item xs={12} sm={5} md={5}>
                    <Typography
                      variant="h5"
                      style={{ ...style.setFont }}
                      gutterBottom={true}
                    >
                      {dish.name}
                      {(liked || isFav) && !props.viewAsDiner && (
                        <IconButton onClick={() => like(dish.id)}>
                          <Icon data-test-id={"dishdet-favourite"} style={{ color: "#ff8000" }}>favorite</Icon>
                        </IconButton>
                      )}

                      {(!isFav && !liked) && !props.viewAsDiner && (
                        <IconButton onClick={() => like(dish.id)}>
                          <Icon data-test-id={"dishdet-favourite"}>favorite_border</Icon>
                        </IconButton>
                      )}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={3} md={3}>
                    <Grid container direction="row" style={{ marginTop: 5 }}>
                      <Grid data-test-id={"dishdet-minsize"} item xs={6} sm={9} md={9}>
                        <Typography
                          variant="subtitle1"
                          style={{
                            ...style.setFont,
                            ...style.setFontGrey,
                          }}
                          gutterBottom={true}
                        >
                          Serves {dish.minDinerSize}
                        </Typography>
                      </Grid>
                      <Grid data-test-id={"dishdet-minprice"} item xs={6} sm={3} md={3} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography
                          variant="subtitle1"
                          style={{
                            ...style.setFont,
                            ...style.setFontGrey,
                          }}
                          gutterBottom={true}
                        >
                          ${dish.minPrice}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Typography
                  data-test-id={"dishdet-cuis"}
                  variant="body2"
                  style={{
                    ...style.setFont,
                    ...style.setFontGrey,
                    marginTop: 20
                  }}
                  gutterBottom={true}
                >
                  {!!dish.cuisines ? dish.cuisines.toString().replace(/,/g, ', ') : ""}
                </Typography>
                <Grid container direction="row" style={{ marginTop: 15, justifyContent: 'flex-start' }}>
                  {dishTypes}
                </Grid>
              </Grid>

              <Hidden mdDown>
                <Grid item lg={1}></Grid>
              </Hidden>
            </Grid>

            <Grid container style={{ marginTop: 83 }}>
              <Grid item data-test-id={"dishdet-desc"} xs={12}>
                <Typography
                  variant="h5"
                  style={style.setFont}
                  gutterBottom={true}
                >
                  Description
                </Typography>
                <Typography variant="body2" dangerouslySetInnerHTML={{
                  __html: dish.description
                }}></Typography>
              </Grid>
              <Grid item xs={12} style={{ marginTop: 60 }} />

              <Grid data-test-id={"dishdet-ing"} item xs={12} md={4} lg={5} style={{marginBottom: 20}}>

                <Typography
                  variant="h5"
                  style={style.setFont}
                  gutterBottom={true}
                >
                  Ingredients
                </Typography>
                <Typography variant="body2" style={style.setFont}>
                  {!!dish.ingredients ? dish.ingredients.toString().replace(/,/g, ', ') : ""}
                </Typography>
              </Grid>
              <Grid data-test-id={"dishdet-minsizebtm"} item xs={12} md={4} lg={3} style={{marginBottom: 20}}>

                <Typography
                  variant="h5"
                  style={style.setFont}
                  gutterBottom={true}
                >
                  Minimum Size
                </Typography>
                <Typography variant="body2" style={style.setFont}>
                  {dish.minDinerSize} diner(s)
                </Typography>
              </Grid>
              {!!dish.equipmentNeeded && dish.equipmentNeeded.length > 0 && <Grid data-test-id={"dishdet-equ"} item xs={12} md={4} lg={4} style={{marginBottom: 20}}>
                <Typography
                  variant="h5"
                  style={style.setFont}
                  gutterBottom={true}
                >
                  Equipments
                </Typography>
                <Typography variant="body2" style={style.setFont}>
                  {!!dish.equipmentNeeded ? dish.equipmentNeeded.toString().replace(/,/g, ', ') : ""}
                </Typography>
              </Grid>}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

const mapPropsToState = state => {
  return {
    userId: state.auth.userId,
    isChef: state.auth.isChef,
    viewAsDiner: state.user.viewAsDiner,
  };
};

const DishDetailPage = connect(mapPropsToState)(DishDetails);

export default DishDetailPage;

const style = {
  avatarImg: {
    width: '100%',
    height: 290,
    borderRadius: 5
  },
  avatarImgWeb: {
    width: '100%',
    height: 450,
    borderRadius: 5
  },
  chefAvatarImg: {
    width: 203,
    height: 203
  },
  setFont: {
    fontFamily: webFont
  },
  setFontGrey: {
    color: textGrey
  },
  btnDishTypeSelected: {
    borderRadius: 20,
    borderColor: primaryColor,
    borderWidth: 1,
    borderStyle: "solid",
    backgroundColor: '#fff',
    color: primaryColor,
    minWidth: 125,
    minHeight: 40,
    marginBottom: 10,
    fontFamily: 'Poppins',
    textTransform: 'none',
    cursor: 'default'
  },
  dishTypeDet: {
    fontSize: 10
  },
  ftGrid: {
    marginTop: 40,
    marginBottom: 10
  },
  ftText: {
    fontFamily: webFont,
    color: textBlack,
    marginLeft: 30,
    weight: 800,
    marginBottom: 30,
    marginTop: 30
  },
  chefName: {
    fontFamily: webFont,
    color: textBlack,
    fontWeight: 500,
    marginLeft: -45
  },
  chefCuisine: {
    fontFamily: webFont,
    color: textGrey,
    weight: 500,
    maxWidth: 400
  },
  featuredItem: {
    marginTop: 20,
    marginBottom: 10
  },
  showBtn: {
    width: "220px",
    borderRadius: 40,
    paddingLeft: 20,
    paddingRight: 20,
    textTransform: "none",
    marginTop: 30
  }
};

